import { PropTypes } from 'prop-types';
import { parseTimeForForm } from 'src/common/form/Interactions/components/utils';

/**
 * @param {timestamp} short timestring in military time (e.g., '15:24:00')
 * @returns {string} Short formatted time with AM/PM (e.g., '03:24 PM')
 */

const TimeDisplay = ({ timestamp }) => {
  const parsedTime = parseTimeForForm(timestamp);

  const hour = parsedTime.hour;
  const minute = parsedTime.minute;
  const ampm = parsedTime.ampm;

  if (!hour || !minute || !ampm) return 'Invalid Time';

  return `${hour}:${minute} ${ampm}`;
};

TimeDisplay.propTypes = {
  timestamp: PropTypes.string.isRequired,
};

export default TimeDisplay;
